/*
 *
 * Estos componentes estan presentes solo en el website
 *
 */

const page="./page/";
// import slick from 'vue-slick';
import BootstrapVue from 'bootstrap-vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
// import VueSweetalert2 from 'vue-sweetalert2';
import SweetModal from 'sweet-modal-vue/src/plugin.js';
import Vue2Filters from 'vue2-filters'
// import VueMarkdown from 'vue-markdown'
import VueSimpleMarkdown from 'vue-simple-markdown'
// import 'vue-simple-markdown/dist/vue-simple-markdown.css'

var VueScrollTo = require('vue-scrollto');

function plugin (Vue) {
	//Componentes llamados
  Vue.component('my-header', require(page+'shared/header.vue').default);
	Vue.component('my-footer', require(page+'shared/footer.vue').default);
	Vue.component('api-img', require(page+'daniel/api-img-pristine.vue').default);
	Vue.component('api-img-pristine', require(page+'daniel/api-img-pristine.vue').default);

  Vue.use(VueSimpleMarkdown)
  Vue.use(BootstrapVue);
  Vue.use(VueAwesomeSwiper, /* { default options with global component } */);
	// Vue.component('slick',slick);
  // Vue.use(VueSweetalert2);
  Vue.use(Vue2Filters);
  Vue.use(SweetModal);

  Vue.use(VueScrollTo, {
     container: "body",
     duration: 500,
     easing: "ease",
     offset: 0,
     force: true,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 });
}

// Install by default if using the script tag
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin)
}

export default plugin
